import { Tables } from "@/types/database.types"
import { supabase } from "@/lib/supabase"

export const industryService = {
  async getAllIndustries(): Promise<{
    data: Tables<"industries">[] | null
    error: Error | null
  }> {
    try {
      const { data, error } = await supabase
        .from("industries")
        .select("*")
        .order("position")
        .order("name")

      if (error) {
        console.error("Error fetching industries:", error)
        return { data: null, error: new Error(error.message) }
      }

      return { data, error: null }
    } catch (error) {
      console.error("Failed to fetch industries:", error)
      return {
        data: null,
        error: error instanceof Error ? error : new Error("Unknown error")
      }
    }
  },

  async getIndustryById(id: string): Promise<{
    data: Tables<"industries"> | null
    error: Error | null
  }> {
    try {
      const { data, error } = await supabase
        .from("industries")
        .select("*")
        .eq("id", id)
        .single()

      if (error) {
        console.error("Error fetching industry:", error)
        return { data: null, error: new Error(error.message) }
      }

      return { data, error: null }
    } catch (error) {
      console.error("Failed to fetch industry:", error)
      return {
        data: null,
        error: error instanceof Error ? error : new Error("Unknown error")
      }
    }
  },

  // Helper function to get display name with emoji
  getDisplayName(industry: Tables<"industries">): string {
    return industry.emoji ? `${industry.emoji} ${industry.name}` : industry.name
  }
} 